import React, { useEffect, useState } from 'react';

import Range from '../Range';
import AudioPlayer from '../../../AudioPlayer';

import notificationSound from '../../../../extras/notification-sound.mp3';

const { Status: AudioStatus } = AudioPlayer;

export interface IVolumeControl {
  className?: string;
  volume: number;
  setVolume: (volume: number) => void;
}

const VolumeControl = ({
  volume,
  className = '',
  setVolume,
}: IVolumeControl) => {
  const [localVolume, setLocalVolume] = useState(volume);
  const [soundStatus, setSoundStatus] = useState(AudioStatus.STOPPED);

  const onChange = volume => {
    setVolume(volume);
    setLocalVolume(volume);

    localStorage.setItem('crm-volume', volume);
  };

  useEffect(() => {
    volume !== localVolume && setSoundStatus(AudioStatus.PLAYING);
  }, [localVolume]);

  const onFinishedPlaying = () => {
    setSoundStatus(AudioStatus.STOPPED);
  };

  return (
    <>
      <AudioPlayer
        autoLoad
        volume={localVolume}
        url={notificationSound}
        playStatus={soundStatus}
        onFinishedPlaying={onFinishedPlaying}
      />
      <Range className={className} value={volume} onChange={onChange} />
    </>
  );
};

export default VolumeControl;
